import { useState, useCallback, useRef } from 'react';
import { getState, compareLoanDetails } from '@helpers';
import { keys } from '@enums';

export default function useLoanDetails(defaultScenarios) {
  const shouldUseDefaultScenario = useRef(true);
  const [loanDetails, _setLoanDetails] = useState(
    defaultScenarios[defaultScenarios.defaultLoanPurpose]
  );

  const setLoanDetails = useCallback(
    (value, name) => {
      _setLoanDetails(prevState => {
        const state = getState(prevState, value, name);

        if (!!state.cashOutAmount) {
          shouldUseDefaultScenario.current = false;
        }

        if (shouldUseDefaultScenario.current) {
          const stateKeys = Object.keys(state).filter(key => {
            return key !== keys.LOAN_PURPOSE && key !== keys.CASH_OUT_AMOUNT;
          });

          if (compareLoanDetails(state, prevState, stateKeys)) {
            return defaultScenarios[state.loanPurpose];
          }

          shouldUseDefaultScenario.current = false;
        }

        return state;
      });
    },
    [defaultScenarios]
  );

  return { loanDetails, setLoanDetails };
}
